import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';
import {Article} from './ArticleService';
import {Survey} from './SurveyService';

export interface Home {
  survey?: Survey;
  articles: Page<Article>;
  categories: string[];
  categoryUses: Record<string, number>;
}

export class HomeService extends AuthenticatedService {
  public home = async (modules: string[]): Promise<IHttpResponse<Home>> => {
    const moduleArg = modules.map(m => `modules=${m}`).join('&');
    const homePage = await this.getAuth<Home>(
      `home?${moduleArg}`,
    );

    return homePage;
  }
}
